import React from "react";
import { Link } from "react-router-dom";
import "./serminars.scss";
import Serminar from "../../assets/images/relativity.jpeg";
export const Serminars = () => {
  return (
    <>
      {" "}
      <div className="serminars">
        <center>
          <h1>TALKS SERMINARS & EVENTS</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Research</h6>
        </div>
      </div>
      <div className="col-md-7 offset-md-2 mt">
        <h6>
          Find here information about seminars, talks, conferences and other
          research events organised by the Physics' Department Research Groups.
        </h6>
        <div className="flexy">
          <div className="col-md-8">
            <img className="" src={Serminar} alt="Scholar" width="100%" />{" "}
          </div>
          <div className="col-md-3 offset-md-1 sem-dates">
            <h6>Upcoming Talks</h6>
            <div className="flexy flexyM mt3">
              <div className="serminar-date col-md-4">
                <center>
                  <h3>10</h3>
                  <h5>OCT</h5>
                </center>
              </div>
              <div className="col-md-8">
                {" "}
                <Link className="links" to={"/"}>
                  Title to be confirmed
                </Link>
              </div>
            </div>
            <div className="flexy flexyM mt3">
              <div className="serminar-date col-md-4">
                <center>
                  <h3>21</h3>
                  <h5>OCT</h5>
                </center>
              </div>
              <div className="col-md-8">
                {" "}
                <Link className="links" to={"/"}>
                  Quantum Mechanics and Many Body Games
                </Link>
              </div>
            </div>
            <div className="flexy flexyM mt3">
              <div className="serminar-date col-md-4 ">
                <center>
                  <h3>11</h3>
                  <h5>JAN</h5>
                </center>
              </div>
              <div className="col-md-8">
                {" "}
                <Link className="links " to={"/"}>
                  Schrödinger in UniPort
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
